import React from "react";


export const SearchBarRequest = () => {
  
  
  return (
    <>
      <div className="flex justify-between items-center top-20 left-9 mx-2">
        <div className='flex text-2xl text-gray-700 font-Poppins font-semibold justify-around bg-gray-100 rounded-lg m-8 py-4 w-full shadow-sm ring-1 ring-gray-300'>
          Respuestas a las publicaciones de pasantias
        </div>
      </div>
    </>
  );
};
